
import debug from "debug";
const log = debug("tree-menu");

function loadTreeMenu(url, target) {
    return fetch(url)
        .then((response)=>{
            // log({response});
            if (response.ok) {
                return response.text();
            }
            return Promise.reject(response);
        }).then((htmlString)=>{
            const parser = new DOMParser();
            const html = parser.parseFromString(htmlString, 'text/html');

            target.after(html.body.firstChild);
            target.remove();

        }).catch(()=>{
            log('error');
        });
}

export default loadTreeMenu;



// WEBPACK FOOTER //
// ./project/client/src/core/modules/tree-menu/load-tree-menu.js